import { render } from "./LaunchAdminScreen.vue?vue&type=template&id=00890f0f&scoped=true&ts=true"
import script from "./LaunchAdminScreen.vue?vue&type=script&lang=ts"
export * from "./LaunchAdminScreen.vue?vue&type=script&lang=ts"

import "./LaunchAdminScreen.vue?vue&type=style&index=0&id=00890f0f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00890f0f"]])

export default __exports__